<template>
    <v-container class="pt-0 pb-5">
        <v-row>
            <v-col cols="12">
                <div class="d-flex flex-column ga-2 pa-2 rounded elevation-1 bg-white">
                    <div>
                        <SportipsButton toPage="Home" chevronLeft>Retour à l'accueil</SportipsButton>

                    </div>
                    <v-alert v-if="!has_bourse_dossards && !is_bourse_dossards_active" border="start" border-color="red"
                        density="compact">Il n'y a pas de bourse aux dossards pour cet
                        évènement</v-alert>
                    <v-alert v-if="has_bourse_dossards && !is_bourse_dossards_active" border="start" border-color="red"
                        density="compact">La bourse aux dossards n'est plus disponible</v-alert>
                    <v-alert v-if="error" border="start" border-color="red" density="compact">{{ error }}</v-alert>
                    <div v-if="is_bourse_dossards_active && !error">
                        <div class="text-h5 font-weight-bold text-darkblue">
                            Un dossard est disponible pour vous
                        </div>
                        <div>Ce lien vous permet de racheter le dossard ci-dessous en vente pour cet évènement.</div>
                        <div class="text-subtitle-1">Ce lien est valable jusqu'au {{
                            $moment(expiration).format("DD/MM/YYYY à HH:mm") }}</div>
                        <div class="text-subtitle-1">Passé ce délai, le lien sera envoyé au suivant participant de la
                            liste d'attente, et vous perdrez votre place. Vous
                            aurez la possibilité de vous réinscrire sur la liste d'attente, si vous le souhaitez. </div>
                        <BourseDossardItemListeAttente v-if="dossard_bourse" :dossard_bourse="dossard_bourse">
                        </BourseDossardItemListeAttente>
                    </div>







                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import BourseDossardItemListeAttente from "@/components/BourseDossards/BourseDossardsItemListeAttente.vue";
import PublicService from "@/services/public.service";
export default {
    name: 'BuyDossardListeAttenteView',
    components: { BourseDossardItemListeAttente },
    data() {
        return {
            dossard_bourse: null,
            token: null,
            error: null,
            expiration: null,
        }
    },
    computed: {
        ...mapStores(useMainStore),
        has_bourse_dossards() {
            return this.mainStore.module.has_bourse_dossards;
        },
        is_bourse_dossards_active() {
            return this.mainStore.module.bourse_dossards_is_active;
        },
    },
    methods: {
        async fetchData() {
            const id_module = this.mainStore.module.id;
            let request = await PublicService.getBourseDossardsItemByToken(id_module, this.token);
            if (request) {
                this.dossard_bourse = request;
                if (this.dossard_bourse.status == 'PAID') {
                    this.error = "Ce dossard n'est plus disponible.";
                    return;
                }
            }
            else {
                this.error = "Une erreur est survenue lors de la récupération du dossard";
                return;
            }
        }
    },
    mounted() {

        if (!this.$route.query.bdt || this.$route.query.bdt == "" || this.$route.query.bdt.length <= 10) {
            this.error = "Ce lien n'est pas valide";
            return;
        }
        //last 10 characters are the timestamp
        const timestamp = this.$route.query.bdt.slice(-10);

        this.expiration = this.$moment(timestamp * 1000).format("YYYY-MM-DD HH:mm:ss");
        if (this.$moment(this.expiration).isBefore(this.$moment())) {
            this.error = "Malheureusement ce lien a expiré, vous ne pouvez plus acheter ce dossard.";
            return;
        }

        const token = this.$route.query.bdt.slice(0, -10);
        if (token) {
            this.token = token;
        }
        else {
            this.error = "Ce lien n'est pas valide";
            return;
        }



        this.fetchData();
    }
}
</script>

<style lang="scss" scoped></style>